import { useMemo, useState } from 'react'
import { CRRender } from '@/components/crRender'
import { Localizer } from '@/utils/langUtils'
import { PROVIDER_REQUEST_SCREENS, PROVIDER_REQUEST_STATUS } from '@/data/status'
import Accepted from './Tabs/Accepted'
import Rejected from './Tabs/Rejected'
import Pending from './Tabs/Pending'
import AllRequests from './Tabs/AllRequests'
import './style.css'
import { StatusField } from '@comp/tableDrawer'
import { PROVIDER_REQUEST_STATUS_MAP } from '@/data/status'
import { DateValue } from '@/components/tableDrawer'
import Tabs from '@/components/tabs'

const ALL_REQUESTS = 0

const REQUESTS_TAB = [
    {
        value: ALL_REQUESTS,
        label: "all-requests",
    }, ...PROVIDER_REQUEST_SCREENS]

const TabsSection = (activeStatus, setter) =>
    <Tabs List={REQUESTS_TAB} onApply={setter} activeTab={activeStatus} />

const ProvidersRR = () => {

    const [activeStatus, setActiveStatus] = useState(ALL_REQUESTS)

    const columns = useMemo(() => [
        { Header: "request-id", accessor: "id", canSearch: true },
        { Header: "provider-name", accessor: "providerName", canSearch: true },
        {
            Header: "status",
            Cell: ({ row: { original } }) =>
                <StatusField id={original?.statusId}
                    value={original?.status}
                    statusMap={PROVIDER_REQUEST_STATUS_MAP} />
        },
        {
            Header: "submission-at",
            Cell: ({ row: { original } }) => <DateValue value={original?.createdAt} />
        },
    ], [])

    const tabsScreen = useMemo(() => columns.filter(column => column.Header != "status"), [])

    return (
        <>
            <CRRender isRender={activeStatus == ALL_REQUESTS}>
                <AllRequests columns={columns} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
            <CRRender isRender={activeStatus == PROVIDER_REQUEST_STATUS?.Pending}>
                <Pending columns={tabsScreen} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
            <CRRender isRender={activeStatus == PROVIDER_REQUEST_STATUS?.Accepted}>
                <Accepted columns={tabsScreen} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
            <CRRender isRender={activeStatus == PROVIDER_REQUEST_STATUS?.Rejected}>
                <Rejected columns={tabsScreen} TabsSection={() => TabsSection(activeStatus, setActiveStatus)} />
            </CRRender>
        </>
    )
}
export default ProvidersRR
